import config from "./config";
import * as msal from "@azure/msal-browser";

const myMSALObj = new msal.PublicClientApplication(config);
myMSALObj.handleRedirectPromise();

export default {
  async getToken() {
    const tokenRequest = {
      account: this.getCurrentAccount(),
      scopes: [process.env.VUE_APP_AZURE_AD_SCOPE]
    };

    if (tokenRequest.account !== null) {
      try {
        let response = await myMSALObj.acquireTokenSilent(tokenRequest);

        return response.accessToken;
      } catch (e) {
        console.error(e);
      }
    }

    //If we didn't return already then we know we need to get the token using a redirect.

    await myMSALObj.acquireTokenRedirect(tokenRequest);
    //Nothing else will execute because we just redirected.
  },

  async signIn() {
    await this.getToken();
  },

  signOut() {
    const logoutRequest = {
      account: this.getCurrentAccount()
    };

    myMSALObj.logoutRedirect(logoutRequest);
  },

  async handleRedirectPromise() {
    await myMSALObj.handleRedirectPromise();
  },

  getCurrentAccount() {
    let activeAccount = myMSALObj.getActiveAccount();

    if (activeAccount == null) {
      const currentAccounts = myMSALObj.getAllAccounts();
      if (currentAccounts.length == 1) {
        myMSALObj.setActiveAccount(currentAccounts[0]);
        activeAccount = currentAccounts[0];
      } else if (currentAccounts.length > 1) {
        // Add choose account code here
        console.warn("Multiple accounts detected.");
      }
    }
    return activeAccount;
  },

  isAuthenticated() {
    return this.getCurrentAccount() !== null;
  },

  async isAuthorized() {
    return (await this.getToken()) !== null;
  }
};
